
import React from 'react';
import {Action, HighlightRects, TextLoading} from "../../funcs/utils";
import {Modal2} from "../modal";
import {render_pair} from "./new-user-dialog";
import {createLPOAItem} from "../SA_UserPortfolios/actions";
import {deep_copy} from "../../../lib/js-utils";
import {sprintf} from "sprintf-js";

const on_create = (component, prms) => () => {
  const { FIRST_NAME, LAST_NAME, EMAIL, ACCOUNT_NUMBERS, PHONE_NUMBER, NUM_ACCT } = prms;
  const num_accts = parseInt(NUM_ACCT.getValue(component.state), 10);
  const wlf_id = component.props.app.wlf.id;
  const prm_list = [ FIRST_NAME, LAST_NAME, EMAIL, PHONE_NUMBER ];
  const all_acct_numbers = [];
  for(let i=0; i < num_accts; i++) {
    prm_list.push(ACCOUNT_NUMBERS[i]);
    all_acct_numbers.push(ACCOUNT_NUMBERS[i].getValue(component.state));
  }
  const acct_line = all_acct_numbers.join(",");
  const highlight_rects = [];

  prm_list.forEach(prm => {
    prm.isFilledElseHighlight(component.state, highlight_rects);
  });

  if (highlight_rects.length > 0) {
    component.setState({ highlight_rects });
    return;
  }

  component.setState({
    creating_lpoa: true,
    lpoa_error: "",
  })
  createLPOAItem(
    component.props.token,
    wlf_id,
    FIRST_NAME.getValue(component.state),
    LAST_NAME.getValue(component.state),
    EMAIL.getValue(component.state),
    PHONE_NUMBER.getValue(component.state),
    acct_line)
    .then(result => {
      console.log("create", result);
      if (result.status === "OK") {
        component.setState({
          show_lpoa_dialog: false,
          creating_lpoa: false,
          lpoa_items: result.payload,
        })
      } else if (result.status === "ERROR" && result.error.msg === "ACCOUNT_ALREADY_EXISTS") {
        component.setState({
          creating_lpoa: false,
          lpoa_error: "Account " + acct_line + " already exists",
        })
      } else if (result.status === "ERROR" && result.error.msg === "USER_ACCOUNT_EXISTS") {
        const email = EMAIL.getValue(component.state);
        component.setState({
          creating_lpoa: false,
          lpoa_error: "User " + email + " already exists",
        })
      } else {
        component.setState({
          creating_lpoa: false,
          lpoa_error: "There was an error",
        })
      }

      console.log("Got", result);
    })
}

const render_acct_numbers = (component, ACCOUNT_NUMBERS, num) => {
  const label_style = {
    marginLeft: "1rem",
  }
  const result = [];
  for(let i=0; i < num; i++) {
    result.push(render_pair(component, sprintf("Account Number %d", i+1), ACCOUNT_NUMBERS[i], label_style));
  }
  return result;
}

const render_plus_minus = (component, NUM_ACCT) => {

  const click = up => () => {
    const state = deep_copy(component.state);
    state.highlight_recs = [];
    NUM_ACCT.setValue(state, sprintf("%d", num_accts + up));
    component.setState(state);
  }

  const container_style = {
    marginTop: "0.5rem",
    width: "100%",
    display: "flex",
  }
  const action_style = {
    padding: "0 1rem",
    marginRight: "1rem",
    fontSize: "1.2rem",
  }
  const num_accts = parseInt(NUM_ACCT.getValue(component.state), 10);

  const do_plus = num_accts < 10;
  const do_minus = num_accts > 1;
  return (
    <div style={container_style}>
      <div style={{flex: "0.5"}}>
        Add/Remove Account #
      </div>
      <div style={{flex: "1"}}>
        { do_plus && <Action onClick={click(1)} style={action_style}>+</Action> }
        { do_minus && <Action onClick={click(-1)} style={action_style}>-</Action> }
      </div>
    </div>
  )
}

const LPOADialog = props => {

  const component = props.component;
  const header = (
    <div align={"center"}>
      <span>Create New LPOA</span>
    </div>
  );

  const on_cancel = () => {
    component.setState({
      show_lpoa_dialog: false,
      highlight_rects: [],
      lpoa_error: "",
      creating_user: false,
    })
  }

  const {
    FIRST_NAME, LAST_NAME, EMAIL, ACCOUNT_NUMBERS, PHONE_NUMBER, NUM_ACCT } = props.prms;
  const button_list = [
    { id: "cancel", label: "Cancel", cb: on_cancel },
    { id: "create",
      label: (
        <TextLoading
          label={"Create"}
          loading={component.state.creating_lpoa}/>),
      cb: on_create(component, props.prms) },
  ];
  const on_highlight_click = () => {
    component.setState({ highlight_rects: [] });
  }
  const has_error = component.state.lpoa_error !== "";
  const error_style = {
    color: "red",
    fontSize: "1rem",
  }
  const error_container_style = {
    paddingTop: "1rem",
    visibility: has_error ? "visible" : "hidden",
  }
  const error = has_error ? component.state.lpoa_error : " ";
  const num_accts = parseInt(NUM_ACCT.getValue(component.state), 10);
  return (
    <Modal2
      header={header}
      buttonList={button_list}>
      <div ref={component.lpoa_dialog_ref} style={{position: "relative"}}>
        <HighlightRects
          rects={component.state.highlight_rects}
          container_ref={component.lpoa_dialog_ref}
          onClick={on_highlight_click}/>
        { render_pair(component, "First Name", FIRST_NAME) }
        { render_pair(component, "Last Name", LAST_NAME) }
        { render_pair(component, "Email", EMAIL) }
        { render_pair(component, "Phone Number", PHONE_NUMBER) }
        { render_plus_minus(component, NUM_ACCT) }
        { render_acct_numbers(component, ACCOUNT_NUMBERS, num_accts) }
        <div align={"center"} style={error_container_style}>
          <span style={error_style}>{error}</span>
        </div>
      </div>
    </Modal2>
  );


}

export { LPOADialog };
